import { render, staticRenderFns } from "./EndNode.vue?vue&type=template&id=33726f5e&scoped=true"
import script from "./EndNode.vue?vue&type=script&lang=js"
export * from "./EndNode.vue?vue&type=script&lang=js"
import style0 from "./EndNode.vue?vue&type=style&index=0&id=33726f5e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33726f5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33726f5e')) {
      api.createRecord('33726f5e', component.options)
    } else {
      api.reload('33726f5e', component.options)
    }
    module.hot.accept("./EndNode.vue?vue&type=template&id=33726f5e&scoped=true", function () {
      api.rerender('33726f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/EndNode.vue"
export default component.exports